// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3Fym0","label":"LabeledBox_label__YzS5_"};